export { FrequentlyBoughtTogetherRenderer } from './FrequentlyBoughtTogetherRenderer'
